<template>
    <div class="selected-filters clearfix">
        <span v-for="tag in tagList"
              :class="'text-appearance selected-filter badge badge-pill badge-dark filter-' + tag.id + ' ' + marginClasses"
              :style="marginInlineStyles"
              @click="removeTag(tag)">
            <template v-if="tag.id === 'price'">
                {{ getPrice(tag.priceMin, 'ceil') | _currency }} - {{ getPrice(tag.priceMax, 'floor') | _currency }}
            </template>
            <template v-else>
               {{ tag.name }} <i class="fa fa-close-x" aria-hidden="true"></i>
            </template>
        </span>
        <span :class="{'d-none' : tagList.length < 2}"
              class="bg-appearance selected-filter reset-all"
              :style="marginInlineStyles"
              @click="resetAllTags()">
            {{ $translate("Ceres::Template.itemFilterReset") }}
        </span>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import {isNullOrUndefined} from 'ceres/app/helper/utils';

import MonetaryFormatter from '~/app/helper/MonetaryFormatter';

export default {
    props: {
        facetData:
        {
          type: Array,
          default()
          {
            return [];
          }
        },
        marginClasses: {
            type: String,
            default: null
        },
        marginInlineStyles: {
            type: String,
            default: null
        }
    },

    created()
    {
      if (!this.$store.state.itemList.facets?.length)
      {
        this.$store.commit("addFacets", this.facetData);
      }
    },

    computed: {
        ...mapState({
            tagList: state => state.itemList.selectedFacets,
            currentPriceType: state => state.localization.currentPriceType
        }),
        appendNet() {

            if(this.currentPriceType === 'b2b') {
                return 'Net';
            }

            return '';
        },
        vatRate() {

            let filtered = App.defaultVatValue.vatRates[0];

            if(!isNullOrUndefined(filtered)) {
                return parseFloat(filtered.vatRate);
            }

            return undefined;
        }
    },

    methods: {

        removeTag(tag) {
            this.selectFacet({ facetValue: tag });
            this.loadItemList();
        },
        resetAllTags() {
            this.resetAllSelectedFacets();
            this.loadItemList();
        },
        getPrice(value, mathFn) {

            if(value <= 0) {
                return value;
            }

            if(!isNullOrUndefined(this.vatRate) && this.vatRate > 0) {

                let vatFactor = (1 + (this.vatRate / 100));

                if(this.currentPriceType === 'b2b') {

                    value = eval('Math.'+mathFn)(((value / vatFactor) + Number.EPSILON) * 100) / 100;

                    return Math.ceil(value - 1);
                }
            }

            return value;
        },
        ...mapMutations([
            "resetAllSelectedFacets"
        ]),
        ...mapActions([
            "selectFacet",
            "loadItemList"
        ])
    },

    filters: {
        _currency(value) {
            return new MonetaryFormatter()
                .format(parseInt(value), App.activeCurrency);
        }
    }
}
</script>
